var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'timer-container pr-5 py-2',
		_vm.close && 'timer-container--close',
		1 && 'timer-container--desktop' ]},[_c('CybermondayTimer',{on:{"close":function($event){_vm.close = !_vm.close}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }